import { render, staticRenderFns } from "./LtkCaption.vue?vue&type=template&id=2ab19316&scoped=true"
import script from "./LtkCaption.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkCaption.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkCaption.vue?vue&type=style&index=0&id=2ab19316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab19316",
  null
  
)

export default component.exports